import "./loading.css"

//Loading component
export const Loading = () => {
    return (
        <div className="spinner-container">
          <div className="loading-spinner">
          </div>
        </div>
      );
};
